// @flow
export const SUBSIDYSPLIT_FILTER_SET = 'reports/SUBSIDYSPLIT_FILTER_SET';
export const SUBSIDYSPLIT_FILTER_UPDATE = 'reports/SUBSIDYSPLIT_FILTER_UPDATE';
export const SUBSIDYSPLIT_FILTER_DEFAULT = 'reports/SUBSIDYSPLIT_FILTER_DEFAULT';
